import { GrapevineOrganizationApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useGrapevineOrganizationApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(
    () => new GrapevineOrganizationApi(configuration),
    [configuration]
  );
};
